import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-gold/30 bg-ink" data-id="element-82" data-mp="3gfsp4jdu96q5">
      <div className="mx-auto max-w-4xl px-5 py-10 text-center" style={{
      paddingTop: "15px",
      paddingBottom: "6px"
    }} data-id="element-83" data-mp="3ghc5e9zhvhrx">
        <p className="font-display text-lg font-bold uppercase tracking-wide text-fog" data-id="element-84" data-mp="36pfu1x8edv5r">
          SIGMA SMART<span className="align-super text-xs text-gold" data-id="element-85" data-mp="3uf0nxb63actt">™</span>
        </p>
        <p className="mt-1 text-sm text-fog/55" data-id="element-86" data-mp="3ucxok0j1r7cf">For assistance, contact:</p>

        <div className="mt-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-fog/75" data-id="element-87" data-mp="387clehl0xbk">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-teal" data-id="element-88" data-mp="3le2j4qntu1a6">
            <MailIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-89" data-mp="29yxe3g083qne" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-teal" data-id="element-90" data-mp="2ezb99xgq7640">
            <InstagramIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-91" data-mp="3l9sjf6xt4wpj" /> @sigmasmart.en
          </a>
        </div>

        <nav aria-label="Legal" className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-fog/50" data-id="element-92" data-mp="3gctpopi22rrv">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-fog" data-id="element-93" data-mp="3q8wr1t532mdr">Terms &amp; Conditions</a>
          <span aria-hidden="true" data-id="element-94" data-mp="82icbryzq8eb">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-fog" data-id="element-95" data-mp="817b9zwxjeqw">Privacy Policy</a>
          <span aria-hidden="true" data-id="element-96" data-mp="33noucq2vvnv">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-fog" data-id="element-97" data-mp="htd2h7fcxs51">Support</a>
        </nav>

        <p className="mt-6 text-xs text-fog/40" data-id="element-98" data-mp="ctgxb4uxbunw">© 2026 SIGMA SMART™ — All rights reserved.</p>
      </div>
    </footer>;
}